import { RefObject, useEffect, useRef } from "react";

export interface ImpressionOptions {
    onImpression: () => void;
    minVisibleRatio: number;
    minVisibleMs: number;
}

export const useImpression = (ref: RefObject<HTMLElement>, { onImpression, minVisibleRatio, minVisibleMs }: ImpressionOptions) => {
    const onImpressionRef = useRef(onImpression);
    onImpressionRef.current = onImpression;

    useEffect(() => {
        const element = ref.current;
        if (!element) return;

        let timeout: ReturnType<typeof setTimeout> | undefined;
        const observer = new IntersectionObserver(
            ([entry]) => {
                clearTimeout(timeout);
                if (!entry.isIntersecting) return;
                timeout = setTimeout(() => {
                    if (document.hidden) return;
                    observer.disconnect();
                    onImpressionRef.current();
                }, minVisibleMs);
            },
            { threshold: minVisibleRatio }
        );
        observer.observe(element);

        return () => {
            clearTimeout(timeout);
            observer.disconnect();
        };
    }, [minVisibleRatio, minVisibleMs]);
};
